import apiClient from '@/plugins/axios';

export default {
	list(params, opts = {}) {
		return apiClient.get('v1/Role', {params, ...opts});
	},

	getRoles(params) {
		let query = '?';
		Object.entries(params).forEach(([key, value]) => {
			if (key === 'currentPage') {
				key = 'pageNumber';
			}

			query += value || value === false || value === 0 ? `${key}=${value}&` : '';
		});

		return apiClient.get(`v1/Role${query}`);
	},

	getRole(roleId) {
		return apiClient.get(`v1/Role/${roleId}`);
	},

	createRole(role) {
		return apiClient.post('v1/Role', role);
	},

	updateRole(role) {
		var roleId = role.id;

		return apiClient.put(`v1/Role/${roleId}`, role);
	},

	deleteRole(roleId) {
		return apiClient.delete(`v1/Role/${roleId}`);
	},

	getExternalRoles(userId, customerId, opts = {}) {
		return apiClient.get(`v1/Role/GetExternalRoles/User/${userId}/Customer/${customerId}`, { ...opts });
	}
};
